module.exports = __webpack_public_path__ + "img/power.72c4a86f.svg";